var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnopenedEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.16,1005h827.68c82,0,148.67-66.69,148.67-148.66V343.66a147.75,147.75,0,0,0-20.5-74.73l-63.08,54.24L626.12,710.9a40.19,40.19,0,0,1-52.23,0L121.08,322.77,58,268.93a147.77,147.77,0,0,0-20.49,74.73V856.35c0,82,66.69,148.66,148.66,148.66Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600,627.32l411-352,72.73-62.68A146.77,146.77,0,0,0,1013.84,195H186.15a146.77,146.77,0,0,0-69.91,17.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnopenedEmail);
export default __webpack_public_path__ + "static/media/unopened-email.081f65ea3b6891646b49dff13bfe10ea.svg";
export { ForwardRef as ReactComponent };